// NewDashboardEditor.jsx - Clone of DashboardEditor.jsx to avoid affecting existing functionality
import React, { useEffect, useRef, useState } from 'react';
import CreativeEditorSDK from '@cesdk/cesdk-js';

const NewDashboardEditor = ({ onEditorReady }) => {
  const containerRef = useRef(null);
  const cesdkInstanceRef = useRef(null);
  const [status, setStatus] = useState('initializing');
  const [error, setError] = useState(null);
  const initializationAttemptedRef = useRef(false);

  useEffect(() => {
    // Skip if already initialized or already attempting initialization
    if (cesdkInstanceRef.current || initializationAttemptedRef.current) {
      return;
    }
    
    initializationAttemptedRef.current = true;
    
    const initEditor = async () => {
      if (!containerRef.current) {
        setError("Container not found");
        return;
      }
      
      try {
        console.log("🚀 Initializing CESDK for new dashboard...");
        
        // Configure CESDK
        const config = {
          license: import.meta.env.VITE_CESDK_LICENSE,
          baseURL: "/cesdk-assets", 
          theme: "light",
          role: "Creator",
          ui: {
            elements: {
              navigation: { enabled: false },
              panels: { enabled: false },
              dock: { enabled: false },
              toolbar: { enabled: false }
            }
          }
        };
        
        // Create CESDK instance
        const cesdk = await CreativeEditorSDK.create(containerRef.current, config);
        
        // Store reference and notify parent
        cesdkInstanceRef.current = cesdk;
        setStatus('ready');
        
        if (onEditorReady && typeof onEditorReady === 'function') {
          onEditorReady(cesdk);
        }
        
        console.log("✅ CESDK initialized successfully for new dashboard");
      } catch (err) {
        console.error("❌ CESDK initialization failed for new dashboard:", err);
        setError(err.message);
        setStatus('error');
        // Clear the flag so initialization can be attempted again if needed
        initializationAttemptedRef.current = false;
      }
    };
    
    initEditor();
    
    // Cleanup function
    return () => {
      if (cesdkInstanceRef.current) {
        try {
          console.log("Disposing CESDK instance for new dashboard");
          cesdkInstanceRef.current.dispose();
          cesdkInstanceRef.current = null;
        } catch (e) {
          console.warn("Error disposing CESDK for new dashboard:", e);
        }
      }
    };
  }, []); // Empty dependency array means this runs once

  return (
    <div>
      {error && <div style={{ color: 'red', padding: '10px' }}>Error: {error}</div>}
      {status === 'initializing' && <div>Initializing editor...</div>}
      <div 
        ref={containerRef}
        style={{ 
          width: '800px', 
          height: '600px',
          position: 'absolute',
          left: '-9999px'
        }}
      ></div>
    </div>
  );
};

export default NewDashboardEditor; 